import axios from "axios";
import qs from "qs";
const state = {
    users: [],
	userCount: 0,
	userInvites: [],
	usersCurrentPage: 0,
	usersSelect: {
		name: 'Active Users',
		value: 'all-active'
	},
	usersQuery: ""
};

const actions = {
    async loadUsers(context,query){
        return axios.get("/api/1/users/paged", query).then(function(response){

            context.commit("setUsers", response.data.result.users)
			context.commit("setUserCount", response.data.result.count)
        });
    },

	async loadUsersPublic(context,query){
        return axios.get("/api/1/users/paged/public", query).then(function(response){

            context.commit("setUsers", response.data.result.users)
			context.commit("setUserCount", response.data.result.count)
        });
    },


	async loadSearchUsers(context){
        return axios.get("/api/1/users/public").then(function(response){
            context.commit("setUsers", response.data.result)
			//context.commit("setUserCount", response.data.result.count)
        });
    },

	async loadUserInvites(context,group_id){
        return axios.get("/api/1/groupCodes",{params:{gid:group_id}}).then(function(response){
			

            context.commit("setUserInvites", response.data.result)
        });
    },
	updateUsersCurrentPage(context,nextPage){
		context.commit("setUsersCurrentPage", nextPage)
	},
	resetUsersParams(context) {
		context.commit("setUsersCurrentPage", 0);
		context.commit("setUsersSelect", {
			name: 'Active Users',
			value: 'all-active'
		});
		context.commit("setUsersQuery","");
	},
	updateUsersSelect(context, newValue) {
		context.commit("setUsersSelect", newValue)
	},
	updateUsersQuery(context, newValue) {
		context.commit("setUsersQuery", newValue)
	}
}

const mutations = {
	setUsers(state,data){
		//uact comes in undefined when it should be just empty string or anything else
		for(var i=0; i<data.length; i++){
			if(!data[i].uact){
				data[i].uact = "";
			}
			if(!data[i].uprm){
				data[i].uprm = "";
			}
		}
		state.users=data;
	},	
	setUserCount(state,data){
		state.userCount=data;
	},	
	setUserInvites(state, data){
		state.userInvites = data;
	},
	setUsersCurrentPage(state, nextPage){
		state.usersCurrentPage  = nextPage;
	},
	setUsersSelect(state, newValue) {
		state.usersSelect = newValue;
	},
	setUsersQuery(state, newValue) {
		state.usersQuery = newValue;
	}
}

const getters = {
	users(state) {
		return state.users
	},
	userCount(state) {
		return state.userCount
	},	
	userInvites(state){
		return state.userInvites
	},
	usersCurrentPage(state){
		return state.usersCurrentPage;
	},
	usersSelect(state){
		return state.usersSelect;
	},
	usersQuery(state){
		return state.usersQuery;
	},
};
  

export default {
    state,
    actions,
    mutations,
    getters
  };